import React from 'react'
import PropTypes from 'prop-types'

import * as S from './styled'

const ErrorMessage = ({ title, subtitle }) => (
  <S.Container>
    <h2>{title}</h2>
    {subtitle && <h3>{subtitle}</h3>}
  </S.Container>
)

ErrorMessage.defaultProps = {
  title: '',
}

ErrorMessage.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
}

export default ErrorMessage
